export default {
    host: process.env.REACT_APP_PROD_HOST
}